export default (object) => {

  let list = []

  for (const key in object) {
    if (object.hasOwnProperty(key))
      list.push(object[key])
  }
  
  return list
}